import axios from "axios";

import Constants from "../../../components.constants.js";

function createPrivilegesMapper(privilegesList){
  let tempPrivilegeInfo = {Basic:[],DAM:[],Archive:[],Advanced:[],"AI Tools":[], "Media Pipeline":[]}
  for (let privilege of privilegesList){
    // tempPrivilegeInfo[privilege.privilege_type].push(privilege)
    tempPrivilegeInfo[privilege.privilege_group].push(privilege)
  }
  return tempPrivilegeInfo
}

function enabledUserActions(currentUserPrivlist, actionsList, userType, enableAIButtonConfig = true){
  let tempActionsList = []
  if (currentUserPrivlist.includes(userType == Constants.adminPrivilege)){
    Array.prototype.push.apply(tempActionsList, actionsList)
  }else{
    for (let priv of currentUserPrivlist){
      Array.prototype.push.apply(tempActionsList, actionsList.filter((action)=>action.action_name == priv))   
    }
    let AIToolActions = actionsList.filter((action)=>action.sub_menu == 'AITOOLACTIONS')
    let additionalAIToolActions = []
    for (let AIAction of AIToolActions){
      if(enableAIButtonConfig){
        //add AITools to the user actions irrespective of privilege access
        if(tempActionsList.findIndex(op=>op.label == AIAction.label) == -1){
          additionalAIToolActions.push(AIAction)
        }
      }
    }
    if(additionalAIToolActions && additionalAIToolActions.length > 0){
      Array.prototype.push.apply(tempActionsList, additionalAIToolActions)
    }
    if(!currentUserPrivlist.includes("Preview")){
      Array.prototype.push.apply(tempActionsList, actionsList.filter((action)=>action.action_name == "Preview"))
    }
    if(currentUserPrivlist.includes("manage-catalogs") && !currentUserPrivlist.includes("rename-catalog")){
      Array.prototype.push.apply(tempActionsList, actionsList.filter((action)=>action.action_name == "rename-catalog"))
    }
    if(currentUserPrivlist.includes("tag-metadata") && !currentUserPrivlist.includes("Bulk Field Update")){
      Array.prototype.push.apply(tempActionsList, actionsList.filter((action)=>action.action_name == "Bulk Field Update"))
    }
    if(!currentUserPrivlist.includes("copy-link")){
      Array.prototype.push.apply(tempActionsList, actionsList.filter((action)=>action.action_name == "copy-link"))
    }
    if(!currentUserPrivlist.includes("set-user-id")){
      Array.prototype.push.apply(tempActionsList, actionsList.filter((action)=>action.action_name == "set-user-id"))
    }
  }
  return tempActionsList
}

export default {
  
  async updateAllUserActionstoInMem(context, payload={}) {
    try {
      let currentUserPriv = []
      Array.prototype.push.apply(currentUserPriv, context.rootState.users.loggedInUserInfo.access_control.privileges)
      context.commit("unsetActionsinfo")
      let startUpData = context.rootState.startUpData;
      if(Object.keys(startUpData).includes("user_groups")){
        for(let u of startUpData["user_groups"]){
          if(u.user_list.includes(context.rootState.users.loggedInUserInfo._id)){
            for(let p of u.access_control.privileges){
                if(!currentUserPriv.includes(u)){
                    currentUserPriv.unshift(p);
                }
            }
          }
        }
      }
      let resp = await axios.get(Constants.userBinActions, payload);
      let enableAIButtonConfig = false
      if('enable_ai_plugin_related_buttons' in context.rootState.startUpData.startUpDataDetails){
        enableAIButtonConfig = context.rootState.startUpData.startUpDataDetails['enable_ai_plugin_related_buttons']
      }
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        context.commit("setActionsinfo", enabledUserActions(currentUserPriv, resp.data.user_actions, context.rootState.users.loggedInUserInfo.user_type, enableAIButtonConfig))
        // if ((resp.data.page +1) <= resp.data.page_count){
        //   context.dispatch("updateAllUserActionstoInMem", {params:{page:resp.data.page + 1}})
        // }
        return {};
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAllUserActionstoInMem][Store][Error occured while getting privilege List--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  
  async updateAllPrivilegetoInMem(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.privileges, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        context.commit("resetPrivileges");
        context.commit("setPrivilegeinfo", createPrivilegesMapper(resp.data.privileges))
        if ((resp.data.page +1) <= resp.data.page_count){
          context.dispatch("updateAllPrivilegetoInMem", {params:{page:resp.data.page + 1}})
        }
        return {};
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAllPrivilegetoInMem][Store][Error occured while getting privilege List--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getAllPrivileges(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.privileges, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllPrivileges][Store][Error occured while getting all privileges--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getUserSettingsPrivilege(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.userSettings, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUserSettingsPrivilege][Store][Error occured while getting user settings privilege--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getUserSpacePrivilege(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.userSpace, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUserSpacePrivilege][Store][Error occured while getting user space privilege--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getUserBinActionsPrivilege(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.userBinActions, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUserBinActionsPrivilege][Store][Error occured while getting user bin actions privilege--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getUserCatalogActionsPrivilege(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.userCatalogActions, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUserCatalogActionsPrivilege][Store][Error occured while getting user catalog actions privilege--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

};
